import { type CSSProperties } from "react";

export function Spinner({ size = 18, color = "currentColor" }: { size?: number; color?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      style={{
        width: size,
        height: size,
        borderRadius: 9999,
        border: `2px solid ${color}`,
        borderTopColor: "transparent",
        display: "inline-block",
        animation: "vocSpin 0.7s linear infinite",
        opacity: 0.7,
      }}
    />
  );
}

/** Shimmer skeleton block for loading placeholders. */
export function Skeleton({
  width = "100%",
  height = 16,
  radius = 6,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: CSSProperties;
}) {
  return (
    <span
      aria-hidden
      style={{
        display: "block",
        width,
        height,
        borderRadius: radius,
        position: "relative",
        overflow: "hidden",
        background: "var(--bg-hover, #1C1C1F)",
        ...style,
      }}
    >
      <span
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent)",
          animation: "vocShimmer 1.4s ease-in-out infinite",
        }}
      />
    </span>
  );
}
